export default __webpack_public_path__ + "static/media/Flag of British Indian Ocean Territory.ab290546.gif";